module.exports = __webpack_public_path__ + "static/img/1.14d23e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting809/images/1.png
// module id = +vAn
// module chunks = 4